import { useDispatch, useSelector } from 'react-redux';
import ContactSalesButton from '@features/Paywall/ContactSalesButton';
import SubscribeForm from '@features/SubscribeForm';
import { useSubscribeForm } from '@features/SubscribeForm/useSubscribeForm';
import Drawer from '@components/Drawer';
import { pricingDrawerUiActions } from '@actions';
import { useTranslation } from '@hooks';
import UpdateSubscriptionReport from './UpdateSubscriptionReport';

const SubscribeDrawer = () => {
    const { isOpen, step, titleKey, subtitleKey, directoriesLocation, loading } = useSelector(
        state => state.pricingDrawerUi,
    );
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const form = useSubscribeForm({ directoriesLocation });

    const onClose = () => dispatch(pricingDrawerUiActions.setOpen({ open: false, type: null }));

    const title = directoriesLocation
        ? t('SubscribeLock.directoriesIntentTitle')
        : titleKey
          ? t(titleKey)
          : form.isUpdate
            ? t('SettingsGeneral.changePlan')
            : t('SettingsGeneral.upgradePlan');
    const subtitle = directoriesLocation
        ? t('SubscribeLock.directoriesIntentSubtitle', { location: directoriesLocation.name })
        : subtitleKey
          ? t(subtitleKey)
          : form.isUpdate
            ? t('SettingsGeneral.changeDescription')
            : t('SettingsGeneral.upgradeDescription');

    const isReport = form.isUpdate && step === 1;

    return (
        <Drawer
            anchor="right"
            open={isOpen}
            onClose={onClose}
            aboveModal
            title={title}
            subtitle={subtitle}
            primaryText={isReport ? t('buttons.confirm') : t('SettingsGeneral.proceedToPayment')}
            primaryDisabled={
                form.isLoading || (isReport && loading) || (form.isUpdate && !form.hasBillableSubscription)
            }
            primaryAction={isReport ? form.onUpdate : form.isUpdate ? form.onPreviewUpdate : form.onSubscribe}
            secondaryText={t('buttons.back')}
            secondaryAction={isReport ? () => dispatch(pricingDrawerUiActions.setStep(0)) : null}
        >
            {isReport ? (
                <UpdateSubscriptionReport />
            ) : (
                <>
                    <SubscribeForm form={form} />
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
                        <ContactSalesButton variant="text" />
                    </div>
                </>
            )}
        </Drawer>
    );
};

export default SubscribeDrawer;
